import { useLocation } from '@packages/router-dom';
import useURLSearchParams from './useURLSearchParams';
import { useRef } from 'react';

export default function useSearchParams(options = {}) {
	const { search } = useLocation();

	return useURLSearchParams(search, options);
}

export { useSearchParams };

export function useRefSearchParams(options = {}) {
	const search = useRef(useLocation().search);

	return useURLSearchParams(search.current, options);
}
